import React from 'react';
import DataTypes from '../../../components/Table/dataTypes';
import { EnrichmentData } from '../constants';
import { ppiInProgressRoute, ppiPublishedRoute } from '../../../routes';
import UpdatesIcon from '../../../components/common/UpdatesIcon';

const formatFormulaCode = formulaCode => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}`;
};

const ppiColumns = enrichmentDataType => ({
  PresentationName: {
    name: 'presentationName',
    dataField: `${enrichmentDataType}.{language}.presentationName`,
    label: 'Product Name',
    translatable: true,
    link: rowData =>
      enrichmentDataType === EnrichmentData.IN_PROGRESS
        ? ppiInProgressRoute(rowData.id)
        : ppiPublishedRoute(rowData.id),
    width: 500
  },
  ItemCode: {
    name: 'itemCode',
    label: 'Item Code',
    dataField: 'itemCode',
    width: 100,
    grow: 0,
    shrink: 0
  },
  MarketFoodID: {
    name: 'ppiItemCode',
    label: 'Market iFood ID',
    calculateCellValue: data => {
      if (data.ppiItemCode === null) {
        return '-';
      }
      if (data.ppiItemCode !== undefined) {
        return formatFormulaCode(data.ppiItemCode);
      }
    },
    width: 200,
    grow: 0,
    shrink: 0
  },
  IFoodID: {
    name: 'iFoodID',
    label: 'Global iFood ID',
    // dataField: 'itemCode',
    calculateCellValue: data => formatFormulaCode(data.itemCode),
    width: 200,
    grow: 0,
    shrink: 0
  },
  ModifyDate: {
    name: 'modifyDate',
    dataField: `${enrichmentDataType}.modifyDate`,
    dataType: DataTypes.Date,
    label: 'Modify Date',
    searchable: false
  },
  ModifiedBy: {
    name: 'modifiedBy',
    dataField: `${enrichmentDataType}.lastModifiedBy`,
    label: 'Modified By'
  },
  Status: {
    name: 'status',
    dataField: `${enrichmentDataType}.enrichmentStatus`,
    label: 'Status',
    width: 100
  },
  ActualPublishedDate: {
    name: 'actualPublishedDate',
    dataField: `${enrichmentDataType}.actualPublishedDate`,
    dataType: DataTypes.Date,
    label: 'Publishing Date',
    searchable: false
  },
  PublishedBy: {
    name: 'publishedBy',
    dataField: `${enrichmentDataType}.publishBy`,
    label: 'Published By',
    width: 250
  },
  // Updates: {
  //   name: 'updates',
  //   dataField: `${enrichmentDataType}.upToDate`,
  //   CellValue: ({ rowData }) => {
  //     const { upToDate } = rowData.data[enrichmentDataType];

  //     return !upToDate && <UpdatesIcon message={rowData.data.id} />;
  //   },
  //   label: 'Updates',
  //   width: 250
  // },
  Updates: {
    name: 'updates',
    CellValue: ({ rowData }) => {
      const { upToDate, updateNotificationList } = rowData.data[
        enrichmentDataType
      ];
      return (
        !upToDate && (
          <UpdatesIcon
            message={updateNotificationList
              .map(notification => notification.message)
              .join(',')}
          />
        )
      );
    },
    label: 'Updates',
    width: 100,
    grow: 0,
    shrink: 0
  }
});

export default ppiColumns;
